import { render, staticRenderFns } from "./Scrolling.vue?vue&type=template&id=5d4be15e"
import script from "./Scrolling.vue?vue&type=script&lang=js"
export * from "./Scrolling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports